import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { Home, User } from '@lmc/ts-common'
import { mixpanel } from '../common/services/analytics'
import useMixpanelEvent, { MixpanelEvents } from './useMixpanelEvent'

const routes: string[] = [
    '/rota/builder',
    '/rota/monitoring',
    '/rota/patterns',
]

const useMixpanelEventsForRoutes = () => {
  const location = useLocation()
  const sendEvent = useMixpanelEvent()
  
  useEffect(() => {
    const currentPath = location.pathname

    const matchingRoute = routes.find(route => {
      return currentPath.startsWith(route)
    })

    if (matchingRoute) {
      sendEvent(MixpanelEvents.PAGE_VISITED, {
        path: currentPath,
        pathname: currentPath,
      })
    }
  }, [location.pathname, routes, sendEvent])
}

export default useMixpanelEventsForRoutes